import ProvidersRepository from 'client-sdk/src/Repository/providers-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  CREATE_PROVIDER,
  CREATE_PROVIDER_FAILED,
  CREATE_PROVIDER_SUCCESS,
  GET_PROVIDERS,
  GET_PROVIDERS_FAILED,
  GET_PROVIDERS_SUCCESS,
  UPDATE_PROVIDER_STATUS,
  UPDATE_PROVIDER_STATUS_FAILED,
  UPDATE_PROVIDER_STATUS_SUCCESS,
} from './constants';

import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getProviders(actions: any): unknown {
  try {
    const {response, count, activeCardCount, inactiveCardCount} =
      yield ProvidersRepository.getProviders(actions);
    yield put({
      type: GET_PROVIDERS_SUCCESS,
      data: response.data,
      count: count.data,
      activeCardCount: activeCardCount.data,
      inactiveCardCount: inactiveCardCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_PROVIDERS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* updateProviderStatus(actions: any): unknown {
  try {
    const {pagination} = actions.payload;
    yield ProvidersRepository.updateProviderStatus(actions);
    yield put({
      type: UPDATE_PROVIDER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_PROVIDERS,
      payload: {...pagination, sort: 'id, desc'},
    });
    handleNotfication('وضعیت تامین کننده با موفقیت تغییر پیدا کرد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_PROVIDER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export function* createProvider(actions: any): unknown {
  try {
    const {pagination, callback} = actions.payload;
    yield ProvidersRepository.createProvider(actions);
    yield put({
      type: CREATE_PROVIDER_SUCCESS,
    });
    yield put({
      type: GET_PROVIDERS,
      payload: {...pagination, sort: 'id, desc'},
    });
    callback();
    handleNotfication('تامین کننده با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_PROVIDER_FAILED,
      error: error.message,
    });
    handleError(error);
  }
}

export default function* providerSaga() {
  yield takeLatest(GET_PROVIDERS, getProviders);
  yield takeLatest(UPDATE_PROVIDER_STATUS, updateProviderStatus);
  yield takeLatest(CREATE_PROVIDER, createProvider);
}
